export const META_PIXEL_ID = '891233500715322'
export const FACEBOOK_DOMAIN_VERIFICATION = 'a8zy1ngjpx6lvb658efxxs5on17se8'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/**
 * Injects the official Meta Pixel base snippet into the document head
 * (plus the <noscript> fallback pixel) and fires the initial PageView.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t: any = b.createElement(e)
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s?.parentNode?.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  /* eslint-enable */

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.alt = ''
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.head.appendChild(noscript)
}

/**
 * Adds <meta name="facebook-domain-verification" ...> to the document head
 * so Meta can verify ownership of this domain.
 */
export function addFacebookDomainVerification(): void {
  if (typeof document === 'undefined') return
  if (document.querySelector('meta[name="facebook-domain-verification"]')) return

  const meta = document.createElement('meta')
  meta.name = 'facebook-domain-verification'
  meta.content = FACEBOOK_DOMAIN_VERIFICATION
  document.head.appendChild(meta)
}

/** Fires the Lead conversion event right before a checkout redirect. */
export function trackLead(): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'Lead')
}
